<template>
  <div
    class="page-block-button w-full flex items-center"
    :class="
      alignmentClass +
      (block.parent?.property('fullWidth', 'number') === 1 ? ' px-4' : '')
    "
  >
    <component
      :is="`tml-button`"
      :text="block.property('text', 'string', null, bindingData)"
      :href="block.property('href')"
      fill
      :class="
        block.parent?.property('fullWidth', 'number') === 1 ||
        block.property('fullWidth', 'number') === 1
          ? 'full-width-button'
          : 'container-width-button'
      "
      :primary="isPrimary"
      :small="block.property('size') === 'small'"
      :large="block.property('size') === 'large'"
      :border-radius="block.property('borderRadius', 'string')"
      :background-color="isPrimary ? block.property('primaryColor') : null"
      :border-color="isPrimary ? null : block.property('secondaryColor')"
      :text-color="isPrimary ? null : block.property('secondaryColor')"
    />
  </div>
</template>

<script>
import blockMixin from '../blockMixin';

export default {
  name: 'PageBlockButton',

  mixins: [blockMixin],

  computed: {
    isPrimary() {
      // buttonStyle on the parent block is set by the two-column-pod builder
      // via the items() tap, giving it the same Property instance as the
      // twoColumnPod template — so changes propagate reactively.
      // Fall back to the button's own primary property for all other contexts.
      const parentStyle = this.block.parent?.property('buttonStyle', 'string');
      if (parentStyle !== undefined) {
        return parentStyle === '1';
      }
      return this.block.property('primary', 'boolean');
    },

    alignmentClass() {
      // Same pattern: prefer buttonAlign from parent when available.
      const parentAlign = this.block.parent?.property('buttonAlign', 'string');
      const align =
        parentAlign ?? this.block.property('align', 'string', 'center');

      switch (align) {
        default:
        case 'left':
          return 'justify-start';

        case 'center':
          return 'justify-center';

        case 'right':
          return 'justify-end';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.full-width-button {
  width: min(100vw, 300px) !important;
}

.container-width-button {
  width: min(calc(100vw - $grid-gutter-width), 300px) !important;
}
</style>
